// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../appDecorationEvents/christmas/Christmas_pastel_phone_background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar__logo {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 10px;
  height: 30px;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.login_page {
  width: 100%;
  max-width: 100%;
  max-height: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.login_page__container {
  width: 100%;
  height: calc(100% - 14em);
  justify-content: center;
  display: flex;
  flex-direction: column;
  gap: 40px;
  margin-top: 5em;
}

.login_input_container {
  padding: 1em 0;
  border: 0.5px solid rgba(136, 166, 207, 0.692);
  background-color: white;
  position: relative;
  display: flex;
  justify-content: center;
  border-radius: 3px;
  margin: 0.5em 0;
}
.login_input_container label {
  font-size: 0.9em;
  opacity: 60%;
  width: 100%;
  position: absolute;
  left: 5px;
  top: 0;
  font-style: italic;
}
.login_input_container input {
  width: 100%;
  border: 0;
  background-color: transparent;
  text-align: center;
}
.login_input_container input:focus {
  outline: none;
  border-bottom: 0;
}
.login_input_container input[readOnly]:focus {
  outline: none;
  border: 0;
}
.login_input_container .showPaswBtn {
  position: absolute;
  right: 5px;
  top: 1em;
}
.login_input_container .hidden {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.login_input_container .error {
  left: 5px;
  top: 2em;
}
.login_input_container.login_input_container__error {
  border: 1px solid rgba(124, 35, 35, 0.593);
  box-shadow: 0px 3px 10px 2px rgba(191, 94, 94, 0.5);
}

.login_form__container {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 20px;
  align-items: "stretch";
  position: relative;
}

.christmas_bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  padding: 60px 40px 70px 40px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Login/src/login.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AACF;AACE;EACE,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;AACJ;;AAGA;EAEE,cAAA;EACA,8CAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;AADF;AAEE;EACE,gBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,MAAA;EACA,kBAAA;AAAJ;AAGE;EACE,WAAA;EACA,SAAA;EACA,6BAAA;EACA,kBAAA;AADJ;AAEI;EACE,aAAA;EACA,gBAAA;AAAN;AAGE;EACE,aAAA;EACA,SAAA;AADJ;AAGE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;AADJ;AAGE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AADJ;AAGE;EACE,SAAA;EACA,QAAA;AADJ;AAIE;EAEE,0CAAA;EACA,mDAAA;AAHJ;;AAOA;EACE,aAAA;EACA,WAAA;EACA,sBAAA;EACA,SAAA;EACA,sBAAA;EACA,kBAAA;AAJF;;AAOA;EACE,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EACA,4BAAA;AAJF","sourcesContent":[".navbar__logo {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 0px;\n  gap: 10px;\n  height: 30px;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n}\n\n.login_page {\n  width: 100%;\n  max-width: 100%;\n  max-height: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n\n  &__container {\n    width: 100%;\n    height: calc(100% - 14em);\n    justify-content: center;\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n    margin-top: 5em;\n  }\n}\n\n.login_input_container {\n  // height: 2em;\n  padding: 1em 0;\n  border: 0.5px solid rgba(136, 166, 207, 0.692);\n  background-color: white;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  border-radius: 3px;\n  margin: 0.5em 0;\n  label {\n    font-size: 0.9em;\n    opacity: 60%;\n    width: 100%;\n    position: absolute;\n    left: 5px;\n    top: 0;\n    font-style: italic;\n  }\n\n  input {\n    width: 100%;\n    border: 0;\n    background-color: transparent;\n    text-align: center;\n    &:focus {\n      outline: none;\n      border-bottom: 0;\n    }\n  }\n  input[readOnly]:focus {\n    outline: none;\n    border: 0;\n  }\n  .showPaswBtn {\n    position: absolute;\n    right: 5px;\n    top: 1em;\n  }\n  .hidden {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n  .error {\n    left: 5px;\n    top: 2em;\n  }\n\n  &.login_input_container__error {\n    // border: 0.5px solid rgba(136, 166, 207, 0.692);\n    border: 1px solid rgba(124, 35, 35, 0.593);\n    box-shadow: 0px 3px 10px 2px rgba(191, 94, 94, 0.5);\n  }\n}\n\n.login_form__container {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  gap: 20px;\n  align-items: \"stretch\";\n  position: relative;\n}\n\n.christmas_bg {\n  background-image: url(\"../../../appDecorationEvents/christmas/Christmas_pastel_phone_background.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: 50% 50%;\n  padding: 60px 40px 70px 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
